module.exports = __webpack_public_path__ + "static/media/t-mobile.ab2f37a4.svg";